<script setup>
import {ref, onMounted, computed} from "vue";
import moment from "moment";
import axios from "axios";
import DashboardView from "./dashboard/DashboardView.vue";
import ReportedTrees from "./dashboard/ReportedTrees.vue";
import ScheduledInspections from "./dashboard/ScheduledInspections.vue";
import WorkReqSection from "./dashboard/works/WorkReqSection.vue";
import {useDefaultsListStore} from "@/stores/defaultsListStore.js";
import {useRoute} from "vue-router";
import PlantingListDashboard from "./dashboard/PlantingListDashboard.vue";
import StumpsListDashboard from "./dashboard/StumpsListDashboard.vue";
import Log from "@/helpers/loggerHelper.js";

const today = moment().format("dddd Do MMM YYYY");
const allActivities = ref(null);
const works = ref(null);
``
const tasks = ref([]);
const totalTrees = ref(null);
const totalParkTrees = ref(null);
const totalStreetTrees = ref(null);
const totalVacantTrees = ref(null);
const totalVacantApproved = ref(null);
const totalWaterTrees = ref(null);
const groups = ref(null);
const permissions = ref(null);
const allClients = ref([]);
const clients = ref([]);
const cid = ref(null);
const access = ref(0);
const tour = ref(false);
const loading = ref(true);
const menuItem = ref(1);
const showMenu = ref(false);
const users = ref(null);
const userId = ref(null);
const page = ref({id: 0, title: "Loading"});
const assignedCount = ref(0);

const defaultsListStore = useDefaultsListStore();
const route = useRoute();

const impersonate = (uid) => {
    window.location.href = `/impersonate/user/${uid}`;
};
const chooseClient = (c_id) => {
    loading.value = true;
    axios
        .post("/api/clients/session", {cid: c_id})
        .then((response) => {
            cid.value = c_id;
            page.value.id = 1;
            page.value.title = "Dashboard";
            window.location.href = "/home";
        })
        .catch((error) => {
            console.log(error);
        });
};

const getSession = () => {
    loading.value = true;
    axios
        .get("/api/clients")
        .then((response) => {
            clients.value = response.data.clients;
            allClients.value = response.data.allClients;
            permissions.value = response.data.clients[0]?.permissions ?? null;
            cid.value = response.data.clients[0]?.id;
            access.value = response.data.clients[0]?.access;
            tour.value = response.data.clients[0]?.show_tour;
            if (permissions.value && permissions.value.dash_activity) {
                getActivity();
                page.value = {id: 1, title: "Dashboard"};
            } else {
                page.value = {id: 2, title: "Assigned to Me"};
                loading.value = false;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

const getActivity = () => {
    loading.value = true;
    axios
        .get("/api/dashboard/activity")
        .then((response) => {
            tasks.value = response.data.workTasks;
            allActivities.value = response.data.allActivity;
            works.value = response.data.maintReq;
            totalTrees.value = response.data.totalTrees;
            totalParkTrees.value = response.data.totalParkTrees;
            totalStreetTrees.value = response.data.totalStreetTrees;
            totalVacantTrees.value = response.data.totalVacantTrees;
            totalVacantApproved.value = response.data.totalVacantApproved;
            totalWaterTrees.value = response.data.totalWaterTrees;
            users.value = response.data.users;
            groups.value = response.data.groups;
            loading.value = false;
        })
        .catch((error) => {
            console.log(error);
            loading.value = false;
        });
};

const getAssignedCount = () => {
    axios
        .get("/api/assign/mine")
        .then((response) => {
            assignedCount.value =
                (response.data.customerRequests?.length ?? 0) +
                (response.data.assignments?.length ?? 0) +
                (response.data.projects?.length ?? 0) +
                (response.data.inspections?.length ?? 0) +
                (response.data.stumps?.length ?? 0);
        })
        .catch((error) => {
            console.error("Error fetching data:", error);
        });
};

const getDefaults = () => {
    let defaultsUrl = "/api/defaults";

    if (route.query.projectId) {
        defaultsUrl = "/api/defaults?projectId=" + route.query.projectId;
    }
    axios.get(defaultsUrl, {}).then((response) => {
        defaultsListStore.updateStoreFields(response.data);
    }).catch((error) => {
        console.error("Error fetching defaults:", error);
        Log.error('fetch-defaults', 'home',error.message, error)
    });
};

const formatWorkTask = (arrayString) => {
    return arrayString.substring(1, arrayString.length - 1).split(",");
};
const getWorkTask = (taskId) => {
    if (parseInt(taskId)) {
        var length = tasks.value.length;
        for (var i = 0; i < length; i++) {
            if (tasks.value[i].id === parseInt(taskId)) {
                return tasks[i].task;
            }
        }
    }
};

const groupBy = (array, fn) => {
    let result = {};
    array.forEach((item) => {
        let key = fn(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    });
    return result;
};

const groupedEvents = computed(() => {
    return groupBy(allActivities.value, (event) => moment(event.created_at).format("dddd Do MMM YYYY"));
});
onMounted(() => {
    getSession();
    getAssignedCount();
    getDefaults();
});

const versionPrint = computed(() => {
    return import.meta.env.APP_VERSION ? `v${import.meta.env.APP_VERSION}` : '';
});

</script>

<template>
    <div>
        <div class="w-full h-64 bg-forestree-green forestree-rounded">
            <div class="relative flex flex-wrap mb-4 lg:flex-no-wrap" style="top: 6rem">
                <div class="p-2 text-center lg:w-1/4"></div>
                <div class="w-full p-4 lg:w-2/4 lg:ml-6">
                    <p v-if="page" class="px-6 text-3xl leading-none text-center lg:text-left">{{ page.title }}</p>
                </div>
                <div class="p-4 lg:w-1/4"></div>
            </div>
            <button
                @click="showMenu = !showMenu"
                class="block w-1/2 px-4 py-2 mx-auto mt-24 mb-2 font-bold text-center bg-white rounded-full lg:hidden hover:bg-blue-700 text-slate-600 hover:text-white"
            >
                Menu
            </button>
        </div>

        <div class="w-full px-1 pt-4 overflow-hidden z-36 lg:pt-0 lg:absolute lg:px-8" style="top: 10rem">
            <div class="flex flex-wrap mb-4 lg:flex-no-wrap">
                <transition name="slide-down">
                    <div :class="showMenu ? 'block' : 'hidden'" class="w-full p-2 text-center lg:block lg:w-1/4">
                        <div class="w-full h-auto px-8 mb-6 md:mb-0 lg:h-32">
                            <div v-if="allClients && allClients.length > 1">
                                <label class="block mb-2 text-xs font-bold tracking-wide uppercase text-slate-700"
                                       for="grid-state"
                                >Change Client<span v-if="loading"> - LOADING ...</span></label
                                >
                                <div class="relative">
                                    <select
                                        v-on:change="chooseClient(cid)"
                                        v-model="cid"
                                        class="block w-full px-4 py-3 pr-8 leading-tight border rounded-lg appearance-none bg-slate-100 border-slate-200 text-slate-700 focus:outline-none focus:bg-white focus:border-slate-500"
                                        id="grid-state"
                                    >
                                        <option v-for="client in allClients" :key="client.id" v-bind:value="client.id">
                                            {{ client.name }}
                                        </option>
                                    </select>
                                    <div
                                        class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none text-slate-700">
                                        <svg class="w-4 h-4 fill-current" xmlns="http://www.w3.org/2000/svg"
                                             viewBox="0 0 20 20">
                                            <path
                                                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="permissions && page"
                             class="h-full tracking-wide lg:border-r lg:border-slate-300 lg:pl-6">
                            <ul class="text-lg text-center lg:text-left text-slate-400">
                                <li v-if="permissions.dash_activity" :class="page.id === 1 ? 'text-slate-700' : ''"
                                    class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 1;
                                            showMenu = false;
                                            page.title = 'Dashboard';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
                                            />
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Dashboard</p>
                                    </a>
                                </li>

                                <li v-if="permissions.dash_assigned_to_me"
                                    :class="page.id === 2 ? 'text-slate-700' : ''" class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 2;
                                            showMenu = false;
                                            page.title = 'Assigned to Me';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path d="M7.667 12H2v8H0V0h12l.333 2H20l-3 6 3 6H8l-.333-2z"/>
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">
                                            Assigned to Me
                                            <span
                                                id="assigned-to-me-badge"
                                                class="inline-block px-2 ml-1 font-semibold bg-white rounded-full text-slate-500"
                                                :class="assignedCount > 0 ? 'bg-red-600 text-red-100' : 'bg-slate-200 text-slate-500'"
                                            >
                                                {{ assignedCount }}</span
                                            >
                                        </p>
                                    </a>
                                </li>

                                <br/>

                                <li v-if="permissions.projects_access" class="py-3 hover:text-slate-600">
                                    <a href="/projects" class="items-center">
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M14 14h4V2H2v12h4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2zM0 2C0 .9.9 0 2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 2h12v2H4V4zm0 3h12v2H4V7zm0 3h12v2H4v-2z"
                                            />
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Projects</p>
                                    </a>
                                </li>

                                <li v-if="permissions.list_insp" :class="page.id === 3 ? 'text-slate-700' : ''"
                                    class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 3;
                                            showMenu = false;
                                            page.title = 'Inspections List';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"/>
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Inspections List</p>
                                    </a>
                                </li>
                                <li v-if="permissions.list_work" :class="page.id === 4 ? 'text-slate-700' : ''"
                                    class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 4;
                                            showMenu = false;
                                            page.title = 'Work Required List';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M6.47 9.8A5 5 0 0 1 .2 3.22l3.95 3.95 2.82-2.83L3.03.41a5 5 0 0 1 6.4 6.68l10 10-2.83 2.83L6.47 9.8z"/>
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Work Required List</p>
                                    </a>
                                </li>
                                <li v-if="permissions.list_plant" :class="page.id === 5 ? 'text-slate-700' : ''"
                                    class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 5;
                                            showMenu = false;
                                            page.title = 'Planting List';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M5.33 12.77A4 4 0 1 1 3 5.13V5a4 4 0 0 1 5.71-3.62 3.5 3.5 0 0 1 6.26 1.66 2.5 2.5 0 0 1 2 2.08 4 4 0 1 1-2.7 7.49A5.02 5.02 0 0 1 12 14.58V18l2 1v1H6v-1l2-1v-3l-2.67-2.23zM5 10l3 3v-3H5z"
                                            />
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Planting List</p>
                                    </a>
                                </li>
                                <li v-if="permissions.list_stump" :class="page.id === 6 ? 'text-slate-700' : ''"
                                    class="py-3 hover:text-slate-600">
                                    <a
                                        href="#"
                                        @click.prevent="
                                            page.id = 6;
                                            showMenu = false;
                                            page.title = 'Stumps Removal List';
                                        "
                                        class="items-center"
                                    >
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M1 4h2v2H1V4zm4 0h14v2H5V4zM1 9h2v2H1V9zm4 0h14v2H5V9zm-4 5h2v2H1v-2zm4 0h14v2H5v-2z"/>
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Stumps Removal List</p>
                                    </a>
                                </li>
                                <br/>
                                <li v-if="permissions.reporting_access" class="py-3 hover:text-slate-600">
                                    <a href="/reporting" class="items-center">
                                        <svg
                                            class="inline-block w-5 h-5 fill-current"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"/>
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Reporting</p>
                                    </a>
                                </li>
                                <li v-if="permissions.admin_access" class="py-3 hover:text-slate-600">
                                    <a href="/admin" class="items-center">
                                        <svg class="inline-block w-5 h-5 fill-current"
                                             xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path
                                                d="M14 14h4V2H2v12h4c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2zM0 2C0 .9.9 0 2 0h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm4 2h12v2H4V4zm0 3h12v2H4V7zm0 3h12v2H4v-2z"
                                            />
                                        </svg>
                                        <p class="inline-block ml-3 align-middle">Admin Settings</p>
                                    </a>
                                </li>
                                <div class="pl-8 text-xs text-gray-400 version-tag">
                                    {{ versionPrint }}
                                </div>

                                <li>
                                    <div v-if="users">
                                        <select
                                            v-on:change="impersonate(userId)"
                                            v-model="userId"
                                            class="block w-5/6 px-4 py-3 pr-8 mt-3 leading-tight border rounded-lg appearance-none bg-slate-100 border-slate-200 text-slate-700 focus:outline-none focus:bg-white focus:border-slate-500"
                                            id="grid-state"
                                        >
                                            <option v-for="user in users.active_users" :key="user.id"
                                                    v-bind:value="user.id">{{ user.name }}
                                            </option>
                                        </select>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </transition>

                <dashboard-view
                    class="w-full xl:w-3/4"
                    v-if="page.id === 1"
                    :allActivities="allActivities"
                    :works="works"
                    :tasks="tasks"
                    :totalTrees="totalTrees"
                    :totalParkTrees="totalParkTrees"
                    :totalStreetTrees="totalStreetTrees"
                    :totalVacantTrees="totalVacantTrees"
                    :totalVacantApproved="totalVacantApproved"
                    :totalWaterTrees="totalWaterTrees"
                    :groups="groups"
                    :loading="loading"
                    :tour="tour"
                    :access="clients[0].access"
                    :permissions="permissions"
                    :storm_mode="defaultsListStore?.defaults?.storm_mode"
                    :activeStorms="defaultsListStore?.activeStorms"
                />

                <reported-trees v-if="page.id === 2" :access="clients[0].access" :permissions="permissions"/>
                <scheduled-inspections v-if="page.id === 3" :access="clients[0].access" :permissions="permissions"/>
                <work-req-section v-if="page.id === 4" :permissions="permissions"/>
                <planting-list-dashboard v-if="page.id === 5" :permissions="permissions"/>

                <stumps-list-dashboard
                    v-if="page.id === 6"
                    :permissions="permissions"
                    :users="users"
                />
            </div>
        </div>
    </div>
</template>

<style>
.modal {
    transition: opacity 0.25s ease;
}

.status.Low:before {
    background-color: #94e185;
    border-color: #78d965;
    box-shadow: 0px 0px 4px 1px #94e185;
}

.status.Medium:before {
    background-color: #ffc182;
    border-color: #ffb161;
    box-shadow: 0px 0px 4px 1px #ffc182;
}

.status.High:before {
    background-color: #c9404d;
    border-color: #c42c3b;
    box-shadow: 0px 0px 4px 1px #c9404d;
}

.status:before {
    content: " ";
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-right: 10px;
    border: 1px solid #000;
    border-radius: 7px;
}

</style>
